<ng-lottie
  width="100%"
  height="100%"
  [options]="options"
  (complete)="completeAnimation.emit()"
  (animationCreated)="animationCreated($event)"
  (domLoaded)="domLoaded()"
></ng-lottie>
